import { LegalLayout, Section } from './LegalLayout';

/**
 * Public Privacy Policy. Required by Twilio toll-free verification alongside
 * the Terms page.
 *
 * The "Sharing" section below carries the sentence carriers specifically look
 * for — that mobile opt-in information is never sold, rented, or shared with
 * third parties for marketing. Its absence is a common rejection cause. Do not
 * soften or remove it.
 */
export function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" updated="August 27, 2026">
      <Section heading="Scope">
        <p>
          This policy covers the information North American Dismantling Corp. (&ldquo;NADC&rdquo;,
          &ldquo;we&rdquo;) collects through its employee text message program and the sign-up page
          for it.
        </p>
      </Section>

      <Section heading="What we collect">
        <p>When you sign up for schedule texts, we collect and store:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Your mobile phone number.</li>
          <li>Your employee number and last name, used only to match you to your employee record.</li>
          <li>The date and time you gave consent, and the exact wording you agreed to.</li>
          <li>The IP address and browser the sign-up came from.</li>
        </ul>
        <p>
          We also keep a record of the schedule messages we send you, whether they were delivered,
          and any reply you send back such as YES, NO, or STOP.
        </p>
      </Section>

      <Section heading="How we use it">
        <p>
          We use this information solely to send you your work schedule, to record whether you
          confirmed your assignments, and to honour opt-out requests. The consent record exists so
          we can show that you agreed to receive these messages.
        </p>
      </Section>

      <Section heading="Sharing">
        <p className="rounded-lg border border-graphite-700 bg-graphite-950 p-3 text-graphite-200">
          <b>
            We do not sell, rent, or share mobile opt-in information or phone numbers with third
            parties for marketing purposes.
          </b>
        </p>
        <p>
          Your number is shared only with the messaging provider that delivers the texts on our
          behalf, and only for that purpose. We may disclose information where the law requires it.
        </p>
      </Section>

      <Section heading="How long we keep it">
        <p>
          We keep your number and consent record for as long as you are an employee receiving
          schedule texts, and afterwards only as long as needed to show that consent was properly
          obtained. Opt-out records are kept indefinitely, because that is what stops us texting you
          again by mistake.
        </p>
      </Section>

      <Section heading="Your choices">
        <p>
          Reply <b>STOP</b> to any message to stop receiving texts, or ask the office to remove your
          number. You may also ask us what number and consent record we hold for you, and ask us to
          correct it.
        </p>
      </Section>

      <Section heading="Security">
        <p>
          Phone numbers and consent records are held in NADC&rsquo;s internal scheduling system,
          reachable only over an encrypted connection and only by authorised office staff.
        </p>
      </Section>

      <Section heading="Changes to this policy">
        <p>
          We may update this policy. The date at the top of this page shows when it last changed.
        </p>
      </Section>

      <Section heading="Contact">
        <p>
          North American Dismantling Corp.
          <br />
          Email: <a className="text-safety-400 underline hover:text-safety-300" href="mailto:mikeperry@nadc1.com">mikeperry@nadc1.com</a>
          <br />
          Web: <a className="text-safety-400 underline hover:text-safety-300" href="https://nadc1.com">nadc1.com</a>
        </p>
      </Section>
    </LegalLayout>
  );
}

export default PrivacyPage;
